import React from 'react';
/**
 * @internal
 */
export const SkeletonThemeContext = /*#__PURE__*/React.createContext({});